import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Importamos los Proveedores de Datos (Base Unificada y Métricas CPanel/Reportes)
import { SegurosDataProvider } from './context/SegurosDataContext';
import { ReportesMetricsProvider } from './context/ReportesMetricsContext';

// Componentes de Autenticación y Panel
import Login from './componentes/login/Login';
import ResetPassword from './componentes/login/ResetPassword';
import Cpanel from './componentes/cpanel/Cpanel';
import RutaProtegida from './componentes/auth/RutaProtegida';

// Componentes de Clientes
import Clientes from './componentes/pages/Clientes/Clientes';
import DetalleCliente from './componentes/pages/DetalleCliente/DetalleCliente';

// Componentes de Pólizas y Contratos
import DetallePoliza from './componentes/pages/DetallePoliza/DetallePoliza';
import DetalleContrato from './componentes/pages/DetalleContrato/DetalleContrato'; 
import ImportarDeudaPage from './componentes/pages/Importacion/ImportarDeudaPage';

// Componentes de Emisión y Cotización
import CargaPolizaPage from './componentes/pages/CargaEmision/CargaPolizaPage';
import CargaCotizacionArtPage from './componentes/pages/CotizacionesArt/CargaCotizacionArtPage'; 

// --- MÓDULOS DE ADMINISTRACIÓN ---
import AdminDashboard from './componentes/pages/Admin/AdminDashboard';
import AdminComisiones from './componentes/pages/Admin/AdminComisiones';
import AdminCompanias from './componentes/pages/Admin/AdminCompanias';
import AdminRiesgos from './componentes/pages/Admin/AdminRiesgos';
import AdminAcuerdos from './componentes/pages/Admin/AdminAcuerdos';
import AdminEquipo from './componentes/pages/Admin/AdminEquipo';
import AdminContadores from './componentes/pages/Admin/AdminContadores';
import ReglasRenovacion from './componentes/pages/Admin/ReglasRenovacion';
import ReportesHub from './componentes/pages/ReporteAvanzados/ReportesHub';
import ReportesAvanzados from './componentes/pages/ReporteAvanzados/ReportesAvanzados';
import ReportesContratos from './componentes/pages/ReporteAvanzados/ReportesContratos';

// Liquidaciones
import AdminLiquidaciones from './componentes/pages/Admin/AdminLiquidaciones/Index';

import BuscadorPolizasPage from './componentes/pages/BuscadorPolizas/BuscadorPolizasPage';
import CargaSiniestroPage from './componentes/pages/CargaSiniestro/CargaSiniestroPage';
import CargaEndosoPage from './componentes/pages/CargarEndoso/CargaEndosoPage';
import BloqueosArt from './componentes/pages/TablerosGestion/ART/Bloqueos/BloqueosArt';
import AumentosArt from './componentes/pages/TablerosGestion/ART/Aumentos/AumentosArt';
import CotizacionesArt from './componentes/pages/TablerosGestion/ART/Cotizaciones/CotizacionesArt';
import RenovacionPolizas from './componentes/pages/TablerosGestion/Renovaciones/RenovacionPolizas';
import CobranzaPolizas from './componentes/pages/TablerosGestion/Cobranza/CobranzaPolizas';
import GestionRefacturaciones from './componentes/pages/TablerosGestion/Cauciones/GestionRefacturaciones';
import PendientePolizas from './componentes/pages/TablerosGestion/Pendientes/TableroPendientes';
import GestionEndosos from './componentes/pages/TablerosGestion/Endosos/GestionEndosos';
import GestionSiniestros from './componentes/pages/TablerosGestion/Siniestros/GestionSiniestros';
import GestionPostVenta from './componentes/pages/TablerosGestion/PostVenta/GestionPostventa';
import GestionPeriodoCorto from './componentes/pages/TablerosGestion/PeriodoCorto/GestionPeriodoCorto';
import RefacturacionPolizas from './componentes/pages/TablerosGestion/Refacturaciones/RefacturacionPolizas';
import CobranzaContratos from './componentes/pages/TablerosGestion/ART/Cobranza/CobranzaContratos';
import FacturacionGestionPage from './componentes/pages/FacturacionGestion/FacturacionGestionPage';
import ProspectosAutos from './componentes/pages/Prospectos/ProspectosAutos';
import ClientesCroselling from './componentes/pages/TablerosGestion/ClientesCroselling/ClientesCroselling';

// IMPORTACIÓN DE COMPONENTES DE COTIZACIÓN
import FormularioCotizacionArt from './componentes/Formularios/FormularioCotizacionArt';
import DetalleCotizacionArt from './componentes/pages/TablerosGestion/ART/DetalleCotizaciones/DetalleCotizacionArt'; 
import DetalleAumentoArt from './componentes/pages/TablerosGestion/ART/DetalleAumentos/DetalleAumentoArt';
import ImportarAumentosArtPage from './componentes/pages/CotizacionesArt/ImportarAumentosArtPage';
import ImportarDeudasArtPage from './componentes/pages/TablerosGestion/ART/Cobranza/ImportarDeudasArtPage';

function App() {
  return (
    <SegurosDataProvider>
      <ReportesMetricsProvider>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Login/>} />
            <Route path='/reset-password' element={<ResetPassword/>} />
            <Route path='/cpanel' element={<RutaProtegida><Cpanel/></RutaProtegida>} />
            
            <Route path='/ImportarDeudaPage' element={<RutaProtegida><ImportarDeudaPage/></RutaProtegida>} />
            <Route path='/clientes' element={<RutaProtegida><Clientes/></RutaProtegida>} />
            <Route path='/clientes/:id' element={<RutaProtegida><DetalleCliente/></RutaProtegida>} />

            <Route path='/clientes/:clientId/polizas/:polizaId' element={<RutaProtegida><DetallePoliza/></RutaProtegida>} />
            <Route path='/clientes/:id/contratos/:contratoId' element={<RutaProtegida><DetalleContrato/></RutaProtegida>} />

            <Route path='/CargaPolizaPage' element={<RutaProtegida><CargaPolizaPage/></RutaProtegida>} />
            <Route path='/CargaCotizacionArtPage' element={<RutaProtegida><CargaCotizacionArtPage/></RutaProtegida>} />
            
            {/* RUTAS DE COTIZACIÓN ART */}
            <Route path='/FormularioCotizacionArt' element={<RutaProtegida><FormularioCotizacionArt/></RutaProtegida>} />
            <Route path='/DetalleCotizacionArt' element={<RutaProtegida><DetalleCotizacionArt/></RutaProtegida>} />
            <Route path='/DetalleAumentoArt' element={<RutaProtegida><DetalleAumentoArt/></RutaProtegida>} />
            <Route path='/importacion-aumentos-art' element={<RutaProtegida><ImportarAumentosArtPage/></RutaProtegida>} />
            
            <Route path='/AdminDashboard' element={<RutaProtegida><AdminDashboard/></RutaProtegida>} />
            <Route path='/admin/comisiones' element={<RutaProtegida><AdminComisiones/></RutaProtegida>} />
            <Route path='/admin/companias' element={<RutaProtegida><AdminCompanias/></RutaProtegida>} />
            <Route path='/admin/riesgos' element={<RutaProtegida><AdminRiesgos/></RutaProtegida>} />
            <Route path='/admin/acuerdos' element={<RutaProtegida><AdminAcuerdos/></RutaProtegida>} />
            <Route path='/admin/equipo' element={<RutaProtegida><AdminEquipo/></RutaProtegida>} />
            <Route path='/admin/contadores' element={<RutaProtegida><AdminContadores/></RutaProtegida>} />
            <Route path='/admin/liquidaciones' element={<RutaProtegida><AdminLiquidaciones/></RutaProtegida>} />
            <Route path='/admin/reglas-renovacion' element={<RutaProtegida><ReglasRenovacion/></RutaProtegida>} />
            <Route path='/admin/facturacion-gestion' element={<RutaProtegida><FacturacionGestionPage/></RutaProtegida>} />

            <Route path='/BuscadorPolizasPage' element={<RutaProtegida><BuscadorPolizasPage/></RutaProtegida>} />
            <Route path='/CargaSiniestroPage' element={<RutaProtegida><CargaSiniestroPage/></RutaProtegida>} />
            <Route path='/CargaEndosoPage' element={<RutaProtegida><CargaEndosoPage/></RutaProtegida>} />
            <Route path='/ReportesHub' element={<RutaProtegida><ReportesHub/></RutaProtegida>} />
            <Route path='/ReportesAvanzados' element={<RutaProtegida><ReportesAvanzados/></RutaProtegida>} />
            <Route path='/ReportesContratos' element={<RutaProtegida><ReportesContratos/></RutaProtegida>} />

            <Route path='/bloqueos-art' element={<RutaProtegida><BloqueosArt/></RutaProtegida>} />
            <Route path='/cotizaciones-art' element={<RutaProtegida><CotizacionesArt/></RutaProtegida>} />
            <Route path='/aumentos-art' element={<RutaProtegida><AumentosArt/></RutaProtegida>} />
            <Route path='/Renovaciones' element={<RutaProtegida><RenovacionPolizas/></RutaProtegida>} />
            <Route path='/Cobranza' element={<RutaProtegida><CobranzaPolizas/></RutaProtegida>} />
            <Route path='/refacturaciones' element={<RutaProtegida><GestionRefacturaciones/></RutaProtegida>} />
            <Route path='/PolizasPendientes' element={<RutaProtegida><PendientePolizas/></RutaProtegida>} />
            <Route path='/GestionEndosos' element={<RutaProtegida><GestionEndosos/></RutaProtegida>} />
            <Route path='/GestionSiniestros' element={<RutaProtegida><GestionSiniestros/></RutaProtegida>} />
            <Route path='/GestionPostVenta' element={<RutaProtegida><GestionPostVenta/></RutaProtegida>} />
            <Route path='/GestionPeriodoCorto' element={<RutaProtegida><GestionPeriodoCorto/></RutaProtegida>} />
            <Route path='/RefacturacionPolizas' element={<RutaProtegida><RefacturacionPolizas/></RutaProtegida>} />
            <Route path='/CobranzaContratos' element={<RutaProtegida><CobranzaContratos/></RutaProtegida>} />
            <Route path='/ImportarDeudasArtPage' element={<RutaProtegida><ImportarDeudasArtPage/></RutaProtegida>} />
            <Route path='/ProspectosAutos' element={<RutaProtegida><ProspectosAutos/></RutaProtegida>} />
            <Route path='/ClientesCroselling' element={<RutaProtegida><ClientesCroselling/></RutaProtegida>} />
            
          </Routes>
        </BrowserRouter>
      </ReportesMetricsProvider>
    </SegurosDataProvider>
  );
}

export default App;
